import React from 'react'
import { Loader } from '../../../Basic/components';
import secureLocalStorage from 'react-secure-storage';
import { useGetUnitOfMeasurementMasterQuery } from '../../../redux/ErpServices/UnitOfMeasurementServices';
import { useEffect } from 'react';
import { useGetStyleMasterByIdQuery } from '../../../redux/ErpServices/StyleMasterServices';
import { DELETE, PLUS } from '../../../icons';

const CuttingDetails = ({ id, readOnly, cuttingDetails, setCuttingDetails, styleId }) => {
  const params = {
    companyId: secureLocalStorage.getItem(
      sessionStorage.getItem("sessionId") + "userCompanyId"
    ),
  };


  const { data: uomList } =
    useGetUnitOfMeasurementMasterQuery({ params: { ...params, isCutting: true } });

  const { data: styleDetails } =
    useGetStyleMasterByIdQuery(styleId, { skip: !styleId });

  const handleInputChange = (value, index, field) => {
    const newBlend = structuredClone(cuttingDetails);
    newBlend[index][field] = value;
    setCuttingDetails(newBlend);
  };

  useEffect(() => {
    if (cuttingDetails.length >= 15) return
    setCuttingDetails(prev => {
      let newArray = Array.from({ length: 15 - prev.length }, i => {
        return { portionId: "", colorId: "", sizeId: "", uomId: "", cuttingPrice: "0.00", orderQty: "0.000" }
      })
      return [...prev, ...newArray]
    }
    )
  }, [setCuttingDetails, cuttingDetails])

  const addRow = () => {
    const newRow = { portionId: "", colorId: "", sizeId: "", uomId: "", cuttingPrice: "0.00", orderQty: "0.000" };
    setCuttingDetails([...cuttingDetails, newRow]);
  };
  const handleDeleteRow = id => {
    setCuttingDetails(yarnBlend => yarnBlend.filter((row, index) => index !== parseInt(id)));
  };
  if (!styleDetails || !uomList) return <Loader />
  const portionDetails = (styleDetails?.data?.portionDetails ? styleDetails?.data?.portionDetails : [])
  return (
    <fieldset disabled={readOnly} className='frame rounded-tr-lg rounded-bl-lg rounded-br-lg w-full border
                            border-gray-600 overflow-auto min-h-[220px]'>
      <legend className='sub-heading'>Cutting Details</legend>
      <div className={`relative w-full overflow-y-auto p-1`}>
        <table className="table-data border border-gray-500 text-xs table-auto w-full">
          <thead className='bg-blue-200 border border-gray-500 top-0'>
            <tr className='border border-gray-500'>
              <th className="table-data w-2 text-center">S.no</th>
              <th className="table-data w-48">Portion</th>
              <th className="table-data w-48">Colors</th>
              <th className="table-data w-32">Size</th>
              <th className="table-data w-20">Uom</th>
              <th className="table-data w-20">Order Qty</th>
              <th className="table-data w-20">Cutting Price</th>
              <th className="table-data w-20">Amount</th>
              {readOnly ?
                "" :
                <th className='w-20  bg-green-600 text-white'>
                  <div onClick={addRow}
                    className='hover:cursor-pointer py-2 flex items-center justify-center bg-green-600 text-white'>
                    {PLUS}
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody className='overflow-y-auto table-data h-full w-full'>
            {cuttingDetails.map((row, index) => (
              <tr key={index} className="w-full table-row">
                <td className='table-data'>{index + 1}</td>
                <td className='table-data '>
                  <select
                    value={row.portionId}
                    onChange={(e) => handleInputChange(e.target.value, index, "portionId")}
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("", index, "portionId") } }}
                    className='text-left w-full rounded py-1 table-data-input'>
                    <option value={""}>
                    </option>
                    {portionDetails.map((item) => (
                      <option value={item.portionId}>
                        {item.Portion.name}
                      </option>
                    ))}
                  </select>
                </td>
                <td className='table-data '>
                  <select
                    value={row.colorId}
                    onChange={(e) => handleInputChange(e.target.value, index, "colorId")}
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("", index, "colorId") } }}
                    className='text-left w-full rounded py-1 table-data-input'>
                    <option hidden value={""}>
                    </option>
                    {(styleDetails?.data?.StyleOnColor ? styleDetails?.data?.StyleOnColor : []).map((item, index) => (
                      <option value={item.colorId}>
                        {item.Color.name}
                      </option>
                    ))}
                  </select>
                </td>
                <td className='table-data'>
                  <select
                    value={row.sizeId}
                    onChange={(e) => handleInputChange(e.target.value, index, "sizeId")}
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("", index, "sizeId") } }}
                    className='text-left w-full rounded py-1 table-data-input'>
                    <option hidden>
                    </option>
                    {(styleDetails?.data?.SizeTemplate?.SizeTemplateOnSize ? styleDetails?.data?.SizeTemplate?.SizeTemplateOnSize : []).map((value, index) => (
                      <option value={value.sizeId}>
                        {value?.Size?.name}
                      </option>
                    ))}
                  </select>
                </td>
                <td className='table-data'>
                  <select
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("", index, "uomId") } }}
                    value={row.uomId} onChange={(e) => handleInputChange(e.target.value, index, "uomId")}
                    disabled={readOnly} className='text-left w-full rounded py-1 table-data-input' >
                    <option hidden>
                    </option>
                    {uomList.data.map((blend) =>
                      <option value={blend.id} key={blend.id}>
                        {blend.name}
                      </option>
                    )}
                  </select></td>
                <td className='table-data'>
                  <input type="number"
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("0.000", index, "orderQty") } }}
                    value={(!row.orderQty) ? 0 : row.orderQty}
                    onChange={(e) => { if (e.target.value >= 0) handleInputChange(e.target.value, index, "orderQty") }}
                    className="text-right rounded py-1 w-full px-1 table-data-input"
                    inputMode='decimal'
                    onBlur={(e) =>
                      handleInputChange(parseFloat(e.target.value).toFixed(3), index, "orderQty")
                    } />
                </td>
                <td className='table-data'>
                  <input type="number"
                    onKeyDown={e => { if (e.key === "Delete") { handleInputChange("0.00", index, "cuttingPrice") } }}
                    value={(!row.cuttingPrice) ? 0 : row.cuttingPrice}
                    onChange={(e) => { if (e.target.value >= 0) handleInputChange(e.target.value, index, "cuttingPrice") }}
                    className="text-right rounded py-1 w-full px-1 table-data-input"
                    inputMode='decimal'
                    onBlur={(e) =>
                      handleInputChange(parseFloat(e.target.value).toFixed(2), index, "cuttingPrice")
                    } />
                </td>
                <td className='table-data'>
                  <input
                    type="number"
                    className="text-right w-full rounded py-1  px-1 table-data-input"
                    value={(!row.orderQty || !row.cuttingPrice) ? 0 : (parseFloat(row.orderQty) * parseFloat(row.cuttingPrice)).toFixed(2)}
                    disabled={true}
                  />
                </td>
                {readOnly
                  ?
                  ""
                  :
                  <td className='table-data w-20'>
                    <div tabIndex={-1} onClick={() => handleDeleteRow(index)} className='flex justify-center px-2 py-1.5 items-center cursor-pointer'>
                      {DELETE}
                    </div>
                  </td>
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </fieldset>
  )
}

export default CuttingDetails